import { FormInstance, InputRef } from 'antd';
import { debounce, delay } from 'lodash';
import cashierApis from 'modules/POS/services/apis';
import { IBillInfoResData } from 'modules/POS/services/types/bill';
import { IGiftCardInfoResData } from 'modules/POS/services/types/gift-card';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { IResponseData } from 'services/response';
import { DollarAmountInputRef } from '../components/DollarAmount/helpers';
const useGetInfoGiftCard = (form?: FormInstance<any>, dollarRef?: React.RefObject<DollarAmountInputRef>, onDone?: () => void) => {
  const inputRef = useRef<InputRef>(null);
  const [code, setCode] = useState<string>('');
  const [msg, setMsg] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [giftCardData, setGifCardData] = useState<IGiftCardInfoResData | null>(null);

  const fetchData = async (code: string) => {
    setMsg('');
    setGifCardData(null);
    if (code?.length < 4) return;
    setLoading(true);
    try {
      const res: IResponseData<IGiftCardInfoResData> = await cashierApis.getGiftCardInfo(code);
      const giftCardData = res.data.data;
      if (res.data.data) {
        setGifCardData(res.data.data);
        if (form) {
          const detail: IBillInfoResData = form.getFieldValue('detail');
          const { amount = 0, usedAmount = 0 } = giftCardData || {};
          const remaining = amount - usedAmount;
          let finalAmount = detail.total;
          if (finalAmount > remaining) {
            finalAmount = remaining;
          }
          form.setFieldValue('amount', finalAmount);
          delay(() => dollarRef?.current?.focus(), 100);
          if (onDone) onDone();
        }
      } else {
        setMsg('Gift number not exist, please try again');
      }
    } catch (error) {
      setMsg('Gift number not exist, please try again');
    }
    finally {
      setLoading(false);
    }
  };
  const fetchStr = async (code: string) => {
    setMsg('');
    setGifCardData(null);
    if (code?.length < 4) return '';
    setLoading(true);
    try {
      const res: IResponseData<IGiftCardInfoResData> = await cashierApis.getGiftCardInfo(code);
      if (res.data.data) return 'Gift number exist, please try again';
      return '';
    } catch (error) {
      return '';
    } finally {
      setLoading(false);
    }
  };

  const fetchDebounce = fetchStr;

  const _debounce = useCallback(debounce(fetchData, 1000), []);

  useEffect(() => {
    _debounce(code);
  }, [code]);

  const onScan = () => undefined;

  const onScanBtn: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    reset();
    e.preventDefault();
    inputRef.current?.focus();
  };

  const resultGiftCard = useMemo(() => {
    const { amount = 0, usedAmount = 0, expiredDate } = giftCardData || {};
    const remaining = amount - usedAmount;
    return ({
      available: remaining || 0,
      amount: amount || 0,
      used: usedAmount || 0,
      expireDate: expiredDate ? moment(expiredDate).format('MM-DD-YYYY') : '--/--/----',
      expireDateV2: expiredDate ? moment(expiredDate).format('MM-DD-YYYY') : '__/__/____',
    });
  }, [giftCardData]);

  const reset = () => {
    setCode('');
    setMsg('');
    setLoading(false);
    setGifCardData(null);
  };

  return ({
    code, setCode,
    msg,
    loading,
    resultGiftCard,
    onScan,
    data: giftCardData,
    reset,
    fetchDebounce,
    inputRef, onScanBtn,
    fetchData,
  });
};
export type IUseGetInfoGiftCardType = ReturnType<typeof useGetInfoGiftCard>;
export default useGetInfoGiftCard;
